import React from 'react';

const About = () => {
  return (
    <div className="about-section">
      <h2>About Ebshops</h2>
      <p>
        Welcome to <strong>Ebshops</strong>, your trusted online marketplace for premium-quality 
        <strong> insecticides, perfumes, and general merchandise</strong>. At Ebshops, we are passionate about 
        providing top-tier products that meet your everyday needs while ensuring affordability and convenience.
      </p>

      <p>
        Whether you're looking to keep your home pest-free with our highly effective insecticides, 
        discover captivating fragrances that leave a lasting impression, or shop for everyday essentials, 
        we’ve got you covered. Our carefully curated selection of products ensures that you get only the 
        best, sourced from trusted brands and suppliers.
      </p>

      <p>
        Customer satisfaction is at the heart of everything we do. We strive to offer a seamless shopping 
        experience, reliable customer support, and fast, efficient delivery. At Ebshops, we believe in 
        quality, affordability, and convenience—all in one place.
      </p>

      <p>
        Thank you for choosing Ebshops. We look forward to serving you and making your shopping experience 
        exceptional.
      </p>
    </div>
  );
};

export default About;
